import HttpClienteToken from '../../services/HttpClientToken';

import { TipoCubiculoProps } from '../../interfaces/catalogos/TipoCubiculoInterface';

export const TipoCubiculo = () => {

    return new Promise<TipoCubiculoProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoCubiculo/', token)
            .then( ({ data } : { data : TipoCubiculoProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerTipoCubiculos = () => {

    return new Promise<TipoCubiculoProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoCubiculo/ObtenerTipoCubiculos', token)
            .then( ({ data } : { data : TipoCubiculoProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarTipoCubiculo = ( params: TipoCubiculoProps ) => {

    return new Promise<TipoCubiculoProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoCubiculo/Actualizar', params, token)
            .then( ({ data } : { data : TipoCubiculoProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoCubiculo: 0,                 
                    descripcion: '',
                    numeroCubiculo: '',
                    activo: false,     
                });
            });
        }

    });

}

export const AgregarTipoCubiculo = ( params: TipoCubiculoProps ) => {

    return new Promise<TipoCubiculoProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoCubiculo/Agregar', params, token)
            .then( ({ data } : { data : TipoCubiculoProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoCubiculo: 0,                   
                    descripcion: '',
                    numeroCubiculo: '',
                    activo: false,    
                });
            });
        }

    });

}